import type {
  InstallHabitAction,
  RemoveHabitAction,
  LoadAvailableHabitsAction,
  CreateHabitAction,
  DeleteHabitAction,
  UpdateHabitAction,
  EditableHabit,
  Habit,
} from "./types";
export function removeHabit(habitId: string): RemoveHabitAction {
  return {
    type: "REMOVE_HABIT",
    habitId,
  };
}
export function loadHabit(userId: string, createdms: number) {
  return {
    type: "LOAD_HABIT",
    userId,
    createdms,
  };
}
export function loadInstalledHabits() {
  return {
    type: "LOAD_INSTALLED_HABITS",
  };
}
export function loadAvailableHabits(
  query: string | null | undefined,
  installed: boolean
): LoadAvailableHabitsAction {
  return {
    type: "LOAD_AVAILABLE_HABITS",
    query,
    installed,
  };
}
export function installHabit(habitId: string): InstallHabitAction {
  return {
    type: "INSTALL_HABIT",
    habitId,
  };
}
export function createHabit(
  habit: EditableHabit,
  install: boolean,
  callback: () => void
): CreateHabitAction {
  return {
    type: "CREATE_HABIT",
    habit,
    install,
    callback,
  };
}
export function deleteHabit(habit: Habit): DeleteHabitAction {
  return {
    type: "DELETE_HABIT",
    habit,
  };
}
export function updateHabit(
  existingHabit: Habit,
  habit: EditableHabit,
  callback: () => void
): UpdateHabitAction {
  return {
    type: "UPDATE_HABIT",
    existingHabit,
    habit,
    callback,
  };
}
